<template>
  <!-- 首页根容器 -->
  <div class="index center">
    <!-- 轮播图 -->
    <div class="banner center">
      <el-carousel ref="banner" :interval="5000" arrow="never">
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <div @click="open(item.jump_url)">
            <el-image class="img_item" :src="item.banner_img" v-if="item.banner_img">
              <div slot="error" style="height: 100%" class="image-slot">
                <div class="error_img"></div>
              </div>
            </el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 累计交易量:垂直轮播(交易统计卡片 + 滚动文字公告) -->
    <div class="TextClass">
      <el-carousel height="80px" direction="vertical" :autoplay="true" indicator-position="none">
        <el-carousel-item v-for="(item, index) in TextList" :key="index">
          <!-- <img :src="item.src" alt="" v-if="item.src" /> -->
          <!-- 交易统计卡片:累计交易数量/金额(接口数据 + 基数换算) -->
          <div v-if="item.src">
            <div class="business center">
              <div class="itemAll">
                <div class="business_item">
                  <div style="margin-top: 11px; margin-bottom: 5px">
                    <img src="../../assets/home_img/1.png" alt="" />
                  </div>
                  <div style="display: flex; align-items: center">
                    <div style="font-size: 14px">累计交易数量</div>
                    <div
                      style="margin-left: 19px; font-size: 20px; font-weight: bolder"
                      v-if="gmv.totalCount">
                      <span>{{ Math.round(Number(gmv.totalCount) / 10000 + 720) }}</span>
                      <span class="mini"> 万吨</span>
                    </div>
                    <div v-else style="color: #fff; font-size: 18px">暂无数据</div>
                  </div>
                </div>
                <div class="business_item">
                  <div style="margin-top: 10px; margin-bottom: 4px">
                    <img src="../../assets/home_img/3.png" alt="" />
                  </div>
                  <div style="display: flex; align-items: center">
                    <div style="font-size: 14px">累计交易金额</div>
                    <div
                      style="margin-left: 19px; font-size: 20px; font-weight: bolder"
                      v-if="gmv.totalPrice">
                      <span>{{ Math.round(Number(gmv.totalPrice) / 10000 + 206200) }}</span>
                      <span class="mini"> 万元</span>
                    </div>
                    <div v-else style="color: #fff; font-size: 18px">暂无数据</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 滚动文字公告内容 -->
          <h3 class="medium">{{ item.content }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 价格指数 + 终端采购招标公示区 -->
    <div class="priceIndex-box">
      <!-- 左侧:煤炭价格指数(点击行打开全屏弹窗) -->
      <!-- <div class="priceIndex-box_left" @click="isShow = true"> -->
      <div class="priceIndex-box_left">
        <PriceIndex @ontableclick="tableClick(1)" :type="1"></PriceIndex>
      </div>
      <!-- 右侧:终端采购招标公示(标题入口 + 表格) -->
      <div class="priceIndex-box_right">
        <div class="purchase-price-left" @click="inquiryBulletinClick">
          <div class="purchase-title">终端采购招标公示</div>
          <div class="purchase-more">点击查看更多</div>
        </div>

        <!-- 招标公示表格(状态列着色:进行中绿/未开始红/其他橙;点击行打开详情弹窗) -->
        <div class="purchase-price-table">
          <el-table
            :data="inquiryBulletinList"
            stripe
            @cell-click="openInquiryBulletinDetail"
            style="width: 100%">
            <el-table-column
              align="center"
              :key="i"
              show-overflow-tooltip
              v-for="(item, i) in inquiryBulletinFields"
              :prop="item.prop"
              :label="item.label"
              :width="item.width">
              <template slot-scope="scope">
                <span
                  class="item_Op"
                  v-if="item.prop == 'billStatusLabel'"
                  :style="{
                    color:
                      scope.row.billStatusLabel == '进行中'
                        ? '#4DC727'
                        : scope.row.billStatusLabel == '未开始'
                        ? '#FF0000'
                        : '#FF8F12',
                  }"
                  >{{ scope.row.billStatusLabel }}</span
                >
                <span v-if="item.prop == 'purchaseName'" style="color: #000000; font-weight: 600">
                  {{
                    scope.row.groupName
                      ? scope.row.groupName + "-" + scope.row.purchaseName
                      : scope.row.purchaseName
                  }}
                </span>
                <span
                  v-if="item.prop != 'billStatusLabel' && item.prop != 'purchaseName'"
                  style="color: #000000; font-weight: 600; font-size: 13px">
                  {{ scope.row[item.prop] }}
                </span>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="empty">当前时间段内无相关数据，请稍后再试！</div>
            </template>
          </el-table>
        </div>
      </div>
      <!-- 价格指数全屏弹窗(再次点击表格关闭) -->
      <el-dialog :visible.sync="isShow" fullscreen class="my-dialog">
        <div class="priceIndex-dialog-box">
          <PriceIndex :type="2" @ontableclick="tableClick(2)"></PriceIndex>
        </div>
      </el-dialog>
    </div>
    <!-- <div class="business center">
      <div class="itemAll">
        <div class="business_item">
          <div style="margin-top: 11px; margin-bottom: 5px">
            <img src="../../assets/home_img/1.png" alt="" />
          </div>
          <div style="display: flex; align-items: center">
            <div style="font-size: 14px">累计交易数量</div>
            <div
              style="margin-left: 19px; font-size: 20px; font-weight: bolder"
              v-if="gmv.totalCount"
            >
              <span>{{ gmv.totalCount }}</span>
              <span class="mini"> 吨</span>
            </div>
            <div v-else style="color: #fff; font-size: 18px">暂无数据</div>
          </div>
        </div>
        <div class="business_item">
          <div style="margin-top: 10px; margin-bottom: 4px">
            <img src="../../assets/home_img/3.png" alt="" />
          </div>
          <div style="display: flex; align-items: center">
            <div style="font-size: 14px">累计交易金额</div>
            <div
              style="margin-left: 19px; font-size: 20px; font-weight: bolder"
              v-if="gmv.totalPrice"
            >
              <span>{{ gmv.totalPrice }}</span>
              <span class="mini"> 元</span>
            </div>
            <div v-else style="color: #fff; font-size: 18px">暂无数据</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 首页主要内容区(竞价/挂牌/邀约/交易预告等列表) -->
    <div class="list_listall">
      <!-- 挂牌销售列表 -->

      <!-- 挂牌采购列表 -->
      <!-- <div class="market_list center">
      <div class="flex_box headbox">
        <div class="boder_bottom">挂牌采购</div>
        <div class="more" @click="tomall(1, 2, 'shinglemarket')" style="cursor: pointer">
          更多+
        </div>
      </div>
      <div class="list_box" v-if="purchaseList.length > 0">
        <div :key="i" class="items" v-for="(item, i) in purchaseList">
          <div class="item-title f-hide item_type" style="display: flex; justify-content: space-between">
            <el-popover placement="top-start" title="" width="200" trigger="hover" :content="item.enterpriseName">
              <div slot="reference" style="
                  width: 220px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                ">
                {{ item.enterpriseName }}
              </div>
            </el-popover>
            <div class="btn_in">
              <el-button type="primary" size="mini" @click="todetail(item.goodsId, 1, 2)">查看详情</el-button>
            </div>
          </div>
          <div class="info">
            <div class="info-left">
              <p class="f-hide">{{ item.goodsName }}</p>
              <p class="f-hide">{{ item.stockCount }}吨</p>
            </div>
            <div class="price" style="color: red; font-weight: bold" :class="[+item.price == 0 ? 'no-price' : '']">
              {{ item.price | priceFilter }}
            </div>
          </div>
          <div class="indicator f-hide2" v-if="item.title">
            <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
              <span>
                <span class="indicator_span">商品指标：{{ item.title }}</span></span>
            </el-tooltip>
          </div>
          <div class="origin f-hide2" style="display: flex">
            <i class="hy-icon-shouhuodizhi"></i>
            <span style="
                width: 164px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
              ">
              {{ item.originPlace }}{{ item.originPlaceDetail }}</span>
          </div>
        </div>
      </div>
      <div class="nodataImg" style="margin-top: 20px" v-else>
        <img src="../../assets/zxx_img/nodata.png" alt="" />
      </div>
    </div> -->
      <!-- 页面左下角固钉 -->
      <div class="right-sticky">
        <div class="right-info right-qr-code">
          <div class="right-info-title">
            微信公众号
            <div class="line"></div>
          </div>
          <div class="right-info-check">了解更多煤炭价格</div>
          <img class="bg" src="@/assets/home_img/6.png" alt="" />
          <div class="right-info-text">新疆煤炭交易中心</div>
        </div>

        <div class="right-info right-freight" @click="freightEntrance">
          <div class="right-info-title">
            运费计算
            <div class="line"></div>
          </div>
          <div class="right-info-check">点击查看更多&gt;</div>
        </div>
      </div>
      <!-- 竞价交易 -->
      <div class="market center" style="margin-top: 34px">
        <!-- 左侧介绍卡:竞价销售/竞价采购/物流竞价入口(物流受环境开关控制) -->
        <div class="Listings">
          <div class="font-size_30">竞价交易</div>
          <div style="margin-top: 17px" class="font-size_16">灵活反应市场，提升资源价值</div>
          <div class="details-list">
            <div style="display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 10px; cursor: pointer" @click="JCXSClick">竞价销售</span>
            </div>
            <div style="margin-top: 20px; display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 13px; cursor: pointer" @click="JJCGClick">竞价采购</span>
            </div>

            <div
              style="margin-top: 20px; display: flex; align-items: center"
              v-if="logisticsModule === 'true'">
              <div class="details-list-dot"></div>
              <span style="margin-left: 13px; cursor: pointer" @click="tomallClick">物流竞价</span>
            </div>
          </div>
        </div>
        <!-- 右侧:竞价列表(tabs 切换 + 表格 + 中标公告侧栏) -->
        <div class="market_left">
          <!-- tabs:竞价销售/竞价采购/物流竞价 -->
          <div class="flex_box headbox">
            <div class="boder_bottom">
              <div @click="handleSelects(1)" :class="activeIndexs == 1 ? 'active_on' : ''">
                竞价销售
              </div>
              <div
                @click="handleSelects(2)"
                :class="activeIndexs == 2 ? 'active_on' : ''"
                class="caigou">
                竞价采购
              </div>
              <div
                @click="handleSelects(3)"
                :class="activeIndexs == 3 ? 'active_on' : ''"
                class="caigou"
                v-if="logisticsModule === 'true'">
                物流竞价
              </div>
            </div>
            <div
              class="mores"
              style="cursor: pointer; font-size: 14px; line-height: 48px"
              @click="tomalls()">
              点击查看更多
            </div>
          </div>
          <!-- 竞价销售table -->
          <div v-if="biddingXList.length > 0 && activeIndexs == 1">
            <el-table :data="biddingXList" @cell-click="ItemClick" stripe height="305">
              <el-table-column
                fixed
                align="center"
                :key="i"
                show-overflow-tooltip
                v-for="(item, i) in tableList"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
                <template slot-scope="scope">
                  <span v-if="item.prop == 'price'" style="color: #d32621; font-weight: 600">{{
                    scope.row.price
                  }}</span>
                  <span
                    class="item_Op"
                    v-if="item.prop == 'goodsStatus'"
                    :style="{
                      color:
                        scope.row.goodsStatus == '进行中'
                          ? '#4DC727'
                          : scope.row.goodsStatus == '未开始'
                          ? '#FF0000'
                          : '#FF8F12',
                    }"
                    >{{ scope.row.goodsStatus }}</span
                  >
                  <span
                    v-if="item.prop != 'goodsStatus' && item.prop != 'price'"
                    style="color: #333333; font-weight: 600">
                    {{ scope.row[item.prop] }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 竞价采购table -->
          <div v-if="biddingTList.length > 0 && activeIndexs == 2">
            <el-table @cell-click="ItemClick" :data="biddingTList" stripe height="305">
              <el-table-column
                fixed
                align="center"
                :key="i"
                v-for="(item, i) in tableList"
                :prop="item.prop"
                show-overflow-tooltip
                :label="item.label"
                :width="item.width">
                <template slot-scope="scope">
                  <span v-if="item.prop == 'price'" style="color: #d32621; font-weight: 600">{{
                    scope.row.price
                  }}</span>
                  <span
                    class="item_Op"
                    v-if="item.prop == 'goodsStatus'"
                    :style="{
                      color:
                        scope.row.goodsStatus == '进行中'
                          ? '#4DC727'
                          : scope.row.goodsStatus == '未开始'
                          ? '#FF0000'
                          : '#FF8F12',
                    }"
                    >{{ scope.row.goodsStatus }}</span
                  >
                  <span
                    v-if="item.prop != 'goodsStatus' && item.prop != 'price'"
                    style="color: #000000; font-weight: 600">
                    {{ scope.row[item.prop] }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 物流竞价table -->
          <div v-if="logisticsList.length > 0 && activeIndexs == 3 && logisticsModule === 'true'">
            <el-table :data="logisticsList" stripe @cell-click="ItemClicks" height="305">
              <el-table-column
                fixed
                align="center"
                :key="i"
                v-for="(item, i) in logisList"
                :prop="item.prop"
                show-overflow-tooltip
                :label="item.label"
                :width="item.width">
                <template slot-scope="scope">
                  <span v-if="item.prop == 'price'" style="color: #d32621; font-weight: 600">{{
                    scope.row.price
                  }}</span>
                  <span
                    class="item_Op"
                    v-if="item.prop == 'goodsStatus'"
                    :style="{
                      color:
                        scope.row.goodsStatus == '进行中'
                          ? '#4DC727'
                          : scope.row.goodsStatus == '未开始'
                          ? '#FF0000'
                          : '#FF8F12',
                    }"
                    >{{ scope.row.goodsStatus }}</span
                  >
                  <span
                    v-if="item.prop != 'goodsStatus' && item.prop != 'price'"
                    style="color: #000000; font-weight: 600">
                    {{ scope.row[item.prop] }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="border-radius: 8px 0px 0px 8px; display: flex; background: #fff">
            <div style="background: #7343d1; border-radius: 9px 0px 0px 9px">
              <!-- <div
                :class="InActive == 1 ? 'active_2' : 'actives'"
                @click="activeClick(1)"
              >
                <div
                  v-show="InActive != 1"
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #fff;
                  "
                ></div>
                <div
                  v-show="InActive == 1"
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #7343d1;
                  "
                ></div>
                <div
                  style="margin-left: 13px; cursor: pointer; font-size: 15px"
                >
                  竞价公告
                </div>
              </div> -->
              <div
                v-if="computedLoginAndAuthentication"
                :class="InActive == 2 ? 'active_2' : 'actives'"
                @click="activeClick(2)">
                <div
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #fff;
                  "></div>
                <div
                  v-show="InActive == 2"
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #7343d1;
                  "></div>
                <div style="cursor: pointer; font-size: 15px; width: 80px; line-height: 62px">
                  中标公告
                </div>
              </div>
              <!-- <div
                :class="InActive == 3 ? 'active_2' : 'actives'"
                v-if="logisticsModule === 'true'"
                @click="activeClick(3)"
              >
                <div
                  v-show="InActive != 3"
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #fff;
                  "
                ></div>
                <div
                  v-show="InActive == 3"
                  style="
                    display: inline-block;
                    width: 4px;
                    height: 32px;
                    background-color: #7343d1;
                  "
                ></div>
                <div
                  style="margin-left: 13px; cursor: pointer; font-size: 15px"
                >
                  物流竞价
                </div>
              </div> -->
            </div>
            <!-- <div class="list_all" v-if="InActive == 1">
              <div
                v-for="(item, i) in biddingList"
                :key="i"
                style="margin-left: 28px"
                @click="
                  tobiddingdeatil('bidding', item.messageId, 'biddingnotice')
                "
              >
                <div class="jingjia_on">竞价</div>
                <div class="jingjia_in">
                  <el-popover
                    placement="top-start"
                    title=""
                    width="203"
                    trigger="hover"
                    :content="item.messageContent"
                  >
                    <div slot="reference" class="messageCont">
                      {{ item.messageContent }}
                    </div>
                  </el-popover>
                </div>
                <div style="margin-top: 6px; color: #ccc">
                  {{ item.createTime }}
                </div>
              </div>
              <div
                class="gengduo"
                v-if="biddingList.length > 0"
                @click="toannouncement('bidding', 'biddingnotice')"
              >
                查看更多
              </div>
            </div> -->
            <!-- 中标公告侧栏(需登录且认证后可见;点击跳转公告详情) -->
            <div class="list_all" v-if="computedLoginAndAuthentication">
              <div
                v-for="(item, i) in winList"
                :key="i"
                style="margin-left: 28px"
                @click="tobiddingdeatil('win', item)">
                <div class="index_info">中标</div>
                <div class="index_infos">
                  <!-- {{ item.messageContent }} -->
                  <el-popover
                    placement="top-start"
                    title=""
                    width="203"
                    trigger="hover"
                    :content="item.messageContent">
                    <div class="index_p" slot="reference">
                      {{ item.messageContent }}
                    </div>
                  </el-popover>
                </div>
                <div style="margin-top: 6px; color: #ccc">
                  {{ item.createTime }}
                </div>
              </div>

              <div
                class="gengduo"
                v-if="winList.length > 0"
                @click="toannouncement('win', 'winnotice')">
                点击查看更多
              </div>
            </div>

            <!-- <div class="list_all" v-if="InActive == 3">
              <div
                v-for="(item, i) in BiddingNotice"
                :key="i"
                style="margin-left: 28px"
                @click="
                  tobiddingdeatil('bidding', item.messageId, 'biddingnotice')
                "
              >
                <div class="jingjia_on">竞价</div>
                <div class="jingjia_in">
                  <el-popover
                    placement="top-start"
                    title=""
                    width="203"
                    trigger="hover"
                    :content="item.messageContent"
                  >
                    <div slot="reference" class="messageCont">
                      {{ item.messageContent }}
                    </div>
                  </el-popover>
                </div>
                <div style="margin-top: 6px; color: #ccc">
                  {{ item.createTime }}
                </div>
              </div>
              <div
                v-if="BiddingNotice.length > 0"
                class="gengduo"
                @click="toannouncement('biddings', 'biddingnotice')"
              >
                查看更多
              </div>
            </div> -->
          </div>
          <!-- <div class="nodataImg" v-else>
          <img src="../../assets/zxx_img/nodata.png" alt="" />
        </div> -->
        </div>
        <!-- <div class="market_right market_righton" style="max-width: 283px">
        <div class="flex_box" style="display: flex; justify-content: center">
          <div class="blue_border" style="margin-top: 5px">竞价公告</div>
        </div>
        <div style="text-align: center" v-if="biddingList.length > 0">
          <div @click="tobiddingdeatil('bidding', item.messageId, 'biddingnotice')" :key="i"
            v-for="(item, i) in biddingList" style="height: 42px; cursor: pointer" class="flex_box">
            <span class="title2">{{ item.messageContent }}</span>
            <span class="data2">{{ item.createTime }}</span>
          </div>
          <div style="cursor: pointer" class="more_tree" @click="toannouncement('bidding', 'biddingnotice')">
            查看更多>>
          </div>
        </div>
        <div class="nodataImg" v-else>
          <img src="../../assets/zxx_img/nodata.png" alt="" />
        </div>
      </div> -->
      </div>
      <!-- 交易预告 -->
      <div class="market_list center" style="margin-top: 20px">
        <!-- left -->
        <div class="list-left">
          <div class="font-size_30">主产区交易预告</div>
          <div class="details-list" style="margin-top: 70px">
            <div style="display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 10px">新陕晋蒙</span>
            </div>
          </div>
        </div>
        <!-- right:五个平台 tabs(5 秒自动轮播)+ 预告卡片列表 -->
        <div style="flex: 1 1 auto">
          <div class="flex_box headbox">
            <div class="boder_bottom">
              <!-- tabs list -->
              <div v-for="(item, index) in transactionNoticeTabsList" :key="index">
                <div
                  @click="handleSelectTransaction(item, index)"
                  :class="transactionCurrent == index ? 'active_on_blue' : ''"
                  class="head_item">
                  {{ item.value }}
                </div>
              </div>
            </div>
            <div class="click_more" @click="goToMore()">点击查看更多</div>
          </div>
          <!-- card list -->
          <div class="list-content">
            <div class="list_box" v-if="transactionNoticeList?.length > 0">
              <div
                :key="i"
                class="list_box_items"
                v-for="(item, i) in transactionNoticeList"
                @click="totransactionNoticedeatil(item)">
                <div class="list_item_content">
                  <div style="margin-left: 15px">
                    <div class="text_weight_500 font-size_20">
                      {{ item.timeMMDD }}
                    </div>
                    <div class="text_span">{{ item.timeYear }}</div>
                  </div>
                  <div class="line"></div>
                  <el-tooltip
                    class="tooltip-item"
                    effect="dark"
                    :content="item.title"
                    placement="top">
                    <div class="text_weight_600 font-size_18 item_title">
                      {{ item.title }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>

            <div class="nodataImg nodata-img-height" v-else>
              <img src="../../assets/zxx_img/nodata.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 挂牌交易 -->
      <div class="market_list center" style="margin-top: 20px" v-if="gplist.length > 0">
        <div class="Listing" style="margin-right: 20px">
          <div style="font-size: 24px">挂牌交易</div>
          <div style="margin-top: 17px">透明、公正、高效的交易方式</div>
          <div style="margin-top: 80px; font-size: 16px; font-weight: 300">
            <div>
              <span style="font-weight: 800">·</span>
              <span style="margin-left: 10px; cursor: pointer" @click="GPXSlick">挂牌销售</span>
            </div>
            <div style="margin-top: 20px">
              <span style="font-weight: 800">·</span>
              <span style="margin-left: 13px; cursor: pointer" @click="GPCGclick">挂牌采购</span>
            </div>
          </div>
        </div>
        <!-- 右侧:tabs(挂牌销售/采购)+ 商品卡片列表 -->
        <div>
          <div class="flex_box headbox">
            <div class="boder_bottom">
              <!-- <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="1">挂牌销售</el-menu-item>
              <el-menu-item index="2">挂牌采购</el-menu-item>
            </el-menu> -->
              <div @click="handleSelect(1)" :class="activeIndex == 1 ? 'active_on' : ''">
                挂牌销售
              </div>
              <div
                @click="handleSelect(2)"
                :class="activeIndex == 2 ? 'active_on' : ''"
                class="caigou">
                挂牌采购
              </div>
            </div>
            <div
              class="more"
              @click="tomall(1, activeIndex, 'shinglemarket')"
              style="cursor: pointer; font-size: 14px; line-height: 48px">
              点击查看更多
            </div>
          </div>
          <!-- 挂牌商品卡片列表(品名/指标/价格/产地/企业/详情按钮) -->
          <div class="list_box" v-if="gplist.length > 0">
            <div :key="i" class="items" v-for="(item, i) in gplist">
              <div style="display: flex; justify-content: space-between">
                <p class="f-hide" style="font-size: 16px; font-weight: bold; width: 200px">
                  <el-popover placement="top-start" title="" width="200" trigger="hover">
                    <span v-for="(goodsName, index) in item.goodsCategoryList" :key="index"
                      >{{ goodsName.goodsName }} &nbsp;
                      {{ index == item.goodsCategoryList.length - 1 ? "" : "|" }}&nbsp;</span
                    >
                    <div
                      slot="reference"
                      style="
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        font-size: 16px;
                        font-weight: bold;
                        width: 200px;
                      ">
                      <span v-for="(goodsName, index) in item.goodsCategoryList" :key="index"
                        >{{ goodsName.goodsName }} &nbsp;
                        {{ index == item.goodsCategoryList.length - 1 ? "" : "|" }}&nbsp;</span
                      >
                    </div>
                  </el-popover>
                </p>
                <p style="font-size: 12px; color: #c5c5c5">
                  <el-popover placement="top-start" title="" width="200" trigger="hover">
                    <div
                      v-for="(goods, index) in item.goodsCategoryList"
                      :key="goods.goodsName + index">
                      <span>{{ goods.goodsName }}:</span>
                      <span
                        v-for="(quota, quotaIndex) in goods.quotas"
                        :key="quota.name + quotaIndex"
                        >{{
                          quota.name +
                          quota.unit.split(";")[2] +
                          quota.value +
                          quota.unit.split(";")[1] +
                          ","
                        }}</span
                      >
                    </div>
                    <div
                      slot="reference"
                      style="
                        width: 118px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                      ">
                      {{ computedQuotas(item.goodsCategoryList) }}
                    </div>
                  </el-popover>
                </p>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 4px;
                  color: #c5c5c5;
                ">
                <p style="font-size: 16px; color: #d32621">
                  <span style="font-size: 14px">{{ item.goodsCategoryList | priceFilter }}</span>
                  <span style="font-size: 12px" v-if="item.goodsCategoryList.length == 1"
                    >元/吨</span
                  >
                </p>
                <p>
                  {{ item.ifConsultRealityCount == 0 ? item.stockCount : "以实际结算数量为准" }}吨
                </p>
              </div>
              <div>
                <div
                  class="origin f-hide2"
                  style="display: flex; font-size: 12px; background: #f2f4ff; padding: 8px 6px">
                  <img
                    src="../../assets/home_img/9.png"
                    alt=""
                    style="width: 12px; height: 14px; margin-top: 1px" />
                  <span
                    style="
                      margin-left: 5px;
                      width: 356px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      display: inline-block;
                    ">
                    {{ item.originPlace }}{{ item.originPlaceDetail }}</span
                  >
                </div>
              </div>

              <div>
                <div
                  class="item-title f-hide item_type"
                  style="display: flex; justify-content: space-between">
                  <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="item.enterpriseName">
                    <div
                      slot="reference"
                      style="
                        width: 220px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        font-size: 14px;
                      ">
                      {{ item.enterpriseName }}
                    </div>
                  </el-popover>
                  <div class="btn_in">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="todetail(item.goodsId, 1, activeIndex)"
                      >查看详情</el-button
                    >
                  </div>
                </div>
              </div>

              <!-- <div
              class="item-title f-hide item_type"
              style="display: flex; justify-content: space-between"
            >
              <el-popover
                placement="top-start"
                title=""
                width="200"
                trigger="hover"
                :content="item.enterpriseName"
              >
                <div
                  slot="reference"
                  style="
                    width: 220px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  "
                >
                  <i
                    class="el-icon-office-building"
                    style="font-size: 18px; color: #3988ef"
                  ></i>
                  {{ item.enterpriseName }}
                </div>
              </el-popover>
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="todetail(item.goodsId, 1, 1)"
                  >查看详情</el-button
                >
              </div>
            </div>
            <div class="info">
              <div
                class="info-left"
                style="display: flex; font-size: 14px; align-items: baseline"
              >
                <p class="f-hide" style="font-size: 16px; font-weight: bold">
                  {{ item.goodsName }}
                </p>
                <p
                  class="f-hide"
                  style="margin-left: 10px; color: red; font-weight: bold"
                >
                  {{ item.stockCount }}吨
                </p>
              </div>
              <div
                class="price"
                style="color: red; font-weight: bold"
                :class="[+item.price == 0 ? 'no-price' : '']"
              >
                {{ item.price | priceFilter }}
              </div>
            </div>
            <div class="indicator f-hide2" v-if="item.title">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start"
              >
                <span>
                  <span class="indicator_span"
                    >商品指标：{{ item.title }}</span
                  ></span
                >
              </el-tooltip>
            </div>
            <div class="origin f-hide2" style="display: flex">
              <i class="hy-icon-shouhuodizhi"></i>
              <span
                style="
                  width: 356px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: inline-block;
                "
              >
                {{ item.originPlace }}{{ item.originPlaceDetail }}</span
              >
            </div> -->
            </div>
          </div>

          <div class="nodataImg" v-else style="margin-top: 20px">
            <img src="../../assets/zxx_img/nodata.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 邀约交易 -->
      <div class="market_list center" style="margin-top: 20px">
        <div class="Listingss">
          <div class="font-size_30">邀约交易</div>
          <div style="margin-top: 17px" class="font-size_16">更精准的交易服务</div>
          <div class="details-list">
            <div style="display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 10px; cursor: pointer" @click="InvitationClick"
                >邀约信息</span
              >
            </div>
          </div>
        </div>
        <div class="Invitation">
          <div class="flex_box headbox">
            <div class="boder_bottom">
              <div @click="handleSelect(1)" :class="activeIndex == 1 ? 'active_on' : ''">
                邀约交易
              </div>
            </div>
            <div
              class="more"
              @click="InvitationClick"
              style="cursor: pointer; font-size: 14px; line-height: 48px">
              点击查看更多
            </div>
          </div>
          <!-- 邀约交易卡片(价格与数量按 viewSet 权限脱敏显示) -->
          <div class="list_box" v-if="InviteList.length > 0">
            <div :key="i" class="items" v-for="(item, i) in InviteList">
              <div style="display: flex; justify-content: space-between">
                <p class="f-hide" style="font-size: 16px; font-weight: bold; width: 200px">
                  <el-popover placement="top-start" title="" width="200" trigger="hover">
                    <span v-for="(goodsName, index) in item.goodsCategoryList" :key="index"
                      >{{ goodsName.goodsName }} &nbsp;
                      {{ index == item.goodsCategoryList.length - 1 ? "" : "|" }}&nbsp;</span
                    >
                    <div
                      slot="reference"
                      style="
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        font-size: 16px;
                        font-weight: bold;
                        width: 200px;
                      ">
                      <span v-for="(goodsName, index) in item.goodsCategoryList" :key="index"
                        >{{ goodsName.goodsName }} &nbsp;
                        {{ index == item.goodsCategoryList.length - 1 ? "" : "|" }}&nbsp;</span
                      >
                    </div>
                  </el-popover>
                </p>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 4px;
                  color: #c5c5c5;
                ">
                <p style="font-size: 16px; color: #d32621">
                  <span style="font-size: 14px">{{
                    item.viewSet && item.viewSet.viewPrice != 1
                      ? "***元/吨"
                      : item.goodsCategoryList.length == 1
                      ? item.goodsCategoryList[0].goodsPrice + "元/吨"
                      : "详情查看价格信息"
                  }}</span>
                </p>
                <p>
                  {{
                    item.viewSet && item.viewSet.viewCount == 0
                      ? "***"
                      : item.ifConsultRealityCount == 0
                      ? item.initialCount + "吨"
                      : "以实际结算数量为准"
                  }}
                </p>
              </div>

              <div style="display: flex; justify-content: space-between">
                <div class="jiaoyi_c">
                  价格类型：{{ item.taxIncluded | taxIncluded }}
                  {{ item.priceType | priceType }}
                </div>
                <div class="jiaoyi_c">配送方式：{{ item.deliveryMode | deliveryMode }}</div>
              </div>
              <div>
                <div
                  class="item-title f-hide item_type"
                  style="display: flex; justify-content: space-between">
                  <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="item.initiatorName">
                    <div
                      slot="reference"
                      style="
                        width: 220px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        font-size: 14px;
                      ">
                      {{ item.initiatorName }}
                    </div>
                  </el-popover>
                  <div class="btn_ins">
                    <el-button type="warning" size="mini" @click="otherdetail(item)"
                      >查看详情</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="nodataImg" v-else style="margin-top: 20px">
            <img src="../../assets/zxx_img/nodata.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 合作平台交易预告 -->
      <div class="market_list center" style="margin-top: 20px" v-if="cooperationList?.length > 0">
        <!-- left -->
        <div class="list-left list-left-taomei">
          <div class="font-size_28">合作平台交易预告</div>
          <div class="details-list" style="margin-top: 70px">
            <div style="display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 10px">淘煤网</span>
            </div>
            <div style="margin-top: 20px; display: flex; align-items: center">
              <div class="details-list-dot"></div>
              <span style="margin-left: 10px">中煤商务</span>
            </div>
          </div>
        </div>
        <!-- right:tabs 按有数据的平台动态生成(淘煤网/中煤商务)+ 预告卡片列表 -->
        <div style="flex: 1 1 auto">
          <div class="flex_box headbox">
            <div class="boder_bottom">
              <!-- tabs list -->
              <div v-for="item in cooperationTabsList" :key="index">
                <div
                  @click="handleSelectCooperation(item)"
                  :class="{ active_on_blue: currentPlatform === item.key }"
                  class="head_item">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="click_more" @click="goToCooperation()">点击查看更多</div>
          </div>
          <!-- card list -->
          <div class="list-content">
            <div class="list_box" v-if="cooperationList?.length > 0">
              <div
                :key="i"
                class="list_box_items"
                v-for="(item, i) in cooperationList"
                @click="toCooperationDeatil(item.url)">
                <div class="list_item_content">
                  <div style="margin-left: 15px">
                    <div class="text_weight_500 font-size_20">
                      {{ item.timeMMDD }}
                    </div>
                    <div class="text_span">{{ item.timeYear }}</div>
                  </div>
                  <div class="line"></div>
                  <el-tooltip
                    class="tooltip-item"
                    effect="dark"
                    :content="item.title"
                    placement="top">
                    <div class="text_weight_600 font-size_18 item_title">
                      {{ item.title }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>

            <!-- <div class="nodataImg nodata-img-height" v-else>
              <img src="../../assets/zxx_img/nodata.png" alt="" />
            </div> -->
          </div>
          <!-- <div class="list_box">
            <div
              :key="i"
              class="list_box_items-taomei"
              v-for="(item, i) in cooperationList"
              @click="toCooperationDeatil(item.url)">
              <div class="text_weight_500 fontSize_16 item_title">{{ item.title }}</div>
              <div style="color: #666">{{ item.time }}</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partner">
      <div class="partner_on">
        <div class="partner_tw">
          <div class="partner_title">合作伙伴</div>
          <div class="partner_title2">新疆煤炭交易中心与合作伙伴一起建设共赢煤炭交易生态圈</div>
        </div>
        <div class="panter_list">
          <div
            @click="toPartner(item.jump_url)"
            class="partner_item"
            :key="i"
            v-for="(item, i) in partnerList">
            <el-image style="width: 180px; height: 72px" :src="item.partner_img" />
          </div>
        </div>
      </div>
    </div>

    <!-- 采购招标公示详情弹窗 -->
    <InquiryBulletinDetail ref="inquiryBulletinDetail"></InquiryBulletinDetail>
  </div>
</template>

<script>
import Vue from "vue";
import Bus from "../../api/eventBus";
Vue.prototype.$bus = Bus;
import {
  getbannerList,
  getpartnerList,
  biddingList,
  gmvdetail,
  nominal,
  getqxshuju,
  sysRotateTextList,
  getinquiryBulletinPage,
  getTradeGoods4NoticeAlist,
  getTaomeiTradeGoodsList,
  getZhongmeiTradeGoodsList,
} from "@/api/home";
import { listTradeInvite } from "@/api/foundation";
import { listTbGoods } from "@/api/Logistics";
import { reqGetToekn, reqBiddingTargeted } from "@/api/public";
const { baseUrl } = require("@/config/index.js");
import { mapState, mapActions } from "vuex";
import * as types from "@/store/action-types";
import PriceIndex from "./components/priceIndex.vue";
import InquiryBulletinDetail from "../inquiryBulletin/components/detail.vue";
import moment from "moment";

/** 合作平台常量配置 */
const PLATFORM_CONFIG = {
  TAOMEI: {
    key: "taomei",
    name: "淘煤网",
    value: 0,
    listUrl: "https://www.taomeiwang.com/tmweb/new/#/trade",
    api: getTaomeiTradeGoodsList,
    dataPath: "data", // 数据在res中的路径
    totalKey: "count", // 总数字段名
    listKey: "data", // 列表字段名
    timeKey: "time", // 时间字段名
  },
  ZHONGMEI: {
    key: "zhongmei",
    name: "中煤商务",
    value: 1,
    listUrl: "https://www.chinacoalst.cn/#/bidding?type=1",
    api: getZhongmeiTradeGoodsList,
    dataPath: "data",
    totalKey: "total",
    listKey: "list",
    timeKey: "begintime",
  },
};

export default {
  data() {
    return {
      /** 价格指数类型(1 半屏,2 全屏) */
      priceIndexType: 1,
      // isSticky: false,
      // stickyOffset: 100,
      /** 价格指数全屏弹窗显示状态 */
      isShow: false,
      /** 测试模块开关(环境变量,当前未使用) */
      testModuls: process.env.VUE_APP_OPEN_TEST_MODULS,
      /** 物流模块开关(环境变量:'true' 时显示物流竞价入口) */
      logisticsModule: process.env.VUE_APP_OPEN_LOGISTICS,
      /** 首页滚动轮播内容(首项为交易统计卡片,其余为文字公告) */
      TextList: [],
      /** 邀约交易列表 */
      InviteList: [],
      /** 中标公告侧栏当前激活项(2=中标公告) */
      InActive: 1,
      /** 挂牌交易当前 tab:1 销售,2 采购 */
      activeIndex: "1",
      /** 竞价交易当前 tab:1 竞价销售,2 竞价采购,3 物流竞价 */
      activeIndexs: "1",
      /** 当前选中导航标题(当前模板未使用) */
      checked: "首页",
      /** 当前用户 ID(0=未登录) */
      userId: 0,
      busData:
        this.$bus.busData === ""
          ? (this.busData = this.$bus.busStorageData)
          : (this.busData = this.$bus.busData),
      /** 预留对象(未使用) */
      navDel: {},
      /** 轮播图列表 */
      bannerList: [{ banner_name: "" }],
      /** 顶部导航菜单配置(当前模板未使用,导航由布局组件渲染) */
      menuList: [
        {
          title: "首页",
          path: "/",
          limit: "all",
        },
        {
          title: "挂牌采购",
          path: "/mall",
          query: {
            selectTradeType: 1,
            selectOrderType: 2,
            title: "挂牌采购",
          },
          limit: "shinglepurchase",
        },
        {
          title: "挂牌销售",
          path: "/mall",
          query: {
            selectTradeType: 1,
            selectOrderType: 1,
            title: "挂牌销售",
          },
          limit: "shinglemarket",
        },
        {
          title: "竞价销售",
          path: "/mall",
          query: {
            selectTradeType: 2,
            selectOrderType: 1,
            title: "竞价销售",
          },
          limit: "biddingmarket",
        },
        {
          title: "竞价采购",
          path: "/mall",
          query: {
            selectTradeType: 2,
            selectOrderType: 2,
            title: "竞价采购",
          },
          limit: "biddingpurchase",
        },
        {
          title: "金融保理",
          path: "/financial",
          id: "14",
          query: {
            id: "14",
            title: "金融保理",
          },
          limit: "financial",
        },
        {
          title: "物流服务",
          path: "/financial",
          query: {
            id: "15",
            title: "物流服务",
          },
          limit: "logistics",
        },
        {
          title: "关于我们",
          path: "/aboutus",
          query: {
            id: "16",
            title: "关于我们",
          },
          limit: "aboutus",
        },
        {
          title: "中长期合同",
          path: "/MediumData",
          query: {
            id: "17",
            title: "中长期合同",
          },
          limit: "MediumData",
        },
      ],
      /** 挂牌交易当前展示列表(随 tab 在销售/采购列表间切换) */
      gplist: [],
      /** 物流竞价列表 */
      logisticsList: [],
      /** 挂牌采购列表 */
      purchaseList: [],
      /** 挂牌销售列表 */
      salesList: [],
      /** 交易统计数据(totalCount 数量/totalPrice 金额) */
      gmv: {},
      /** 竞价销售列表 */
      biddingXList: [],
      /** 竞价采购列表 */
      biddingTList: [],
      /** 竞价公告列表(当前模板已停用) */
      biddingList: [],
      /** 物流竞价公告列表(当前模板已停用) */
      BiddingNotice: [],
      /** 中标公告列表 */
      winList: [],
      /** 合作伙伴列表 */
      partnerList: [],
      /** 终端采购招标公示列表 */
      inquiryBulletinList: [],
      /** 物流竞价列表字段 */
      logisList: [
        {
          prop: "goodsName",
          width: "",
          label: "货物名称",
        },
        {
          prop: "floorPrice",
          width: "",
          label: "竞价限价(元/吨)",
        },
        {
          prop: "monthFreightVolume",
          width: "",
          label: "发运量(吨)",
        },
        {
          prop: "lineName",
          width: "",
          label: "线路名称",
        },
        {
          prop: "transportDistance",
          width: "",
          label: "运距(公里)",
        },
        {
          prop: "biddingStartTime",
          width: "",
          label: "竞价开始时间",
        },
        {
          prop: "biddingEndTime",
          width: "",
          label: "竞价结束时间",
        },
        {
          prop: "biddingStatus",
          width: "",
          label: "状态",
        },
      ],
      /** 竞价销售，竞价采购列表字段 */
      tableList: [
        {
          prop: "goodsName",
          width: "",
          label: "商品名称",
        },
        {
          prop: "price",
          width: "120",
          label: "竞价底价(元)",
        },
        {
          prop: "stockCount",
          width: "100",
          label: "数量(吨)",
        },
        {
          prop: "deliveryPlace",
          width: "200",
          label: "交割地点",
        },
        {
          prop: "enterpriseName",
          width: "",
          label: "供应单位",
        },
        {
          prop: "biddingStartTime",
          width: "116",
          label: "竞价开始时间",
        },
        {
          prop: "biddingEtartTime",
          width: "116",
          label: "竞价结束时间",
        },
        {
          prop: "goodsStatus",
          width: "",
          label: "状态",
        },
      ],
      /** 采购招标公示表格字段配置 */
      inquiryBulletinFields: [
        {
          prop: "goodsName",
          width: "",
          label: "商品名称",
        },
        {
          prop: "purchaseName",
          width: "",
          label: "采购集团-单位",
        },
        {
          prop: "goodsQty",
          width: "",
          label: "数量(吨)",
        },
        {
          prop: "expireEndTime",
          width: "",
          label: "截止报名时间",
        },
        {
          prop: "billStatusLabel",
          width: "",
          label: "状态",
        },
      ],
      /** 交易预告标签列表 */
      transactionNoticeTabsList: [
        {
          platformType: "xjPage",
          value: "新疆煤炭交易中心",
        },
        {
          platformType: "tyPage",
          value: "中国太原煤炭交易中心",
        },
        {
          platformType: "sxPage",
          value: "陕西煤炭交易中心",
        },
        {
          platformType: "nmgPage",
          value: "内蒙古煤炭交易中心",
        },
        {
          platformType: "gnPage",
          value: "国能互通",
        },
      ],
      /** 交易预告当前标签索引 */
      transactionCurrent: 0,
      /** 交易预告列表 */
      transactionNoticeList: [],
      /** 交易预告全量数据(按平台 platformType 分组,含 records) */
      transactionNoticeListAll: {},
      /** 定时器 */
      timer: null,
      // regionData: regionData,
      /** 合作平台交易预告 - tabs配置 */
      cooperationTabsList: [],
      /** 各合作平台数据 */
      platformData: {
        taomei: [],
        zhongmei: [],
      },
      /** 当前选中的平台 */
      currentPlatform: "taomei",
      /** 合作平台交易预告 - 列表 */
      cooperationList: [],
    };
  },
  components: {
    /** 采购招标公示详情弹窗 */
    InquiryBulletinDetail,
    /** 煤炭价格指数组件 */
    PriceIndex,
  },
  /** 初始化:获取游客 token,读取用户 ID */
  created() {
    this.gettoken();
    this.userId = Vue.ls.get("userId") || 0;
  },
  /** 挂载:登录态与认证状态检查 */
  mounted() {
    this.jurisdiction();

    //this.stickyOffset = this.$el.offsetTop;
    //window.addEventListener("scroll", this.handleScroll);
  },
  filters: {
    /** 配送方式:1 送货,2 自提 */
    deliveryMode(val) {
      switch (val) {
        case 1:
          return "送货";
        case 2:
          return "自提";
      }
    },
    /** 是否含税:0 含税,1 不含税 */
    taxIncluded(val) {
      let arr = ["含税", "不含税"];
      return arr[val];
    },
    /** 价格类型:1 坑口价 ~ 6 到厂价 */
    priceType(val) {
      switch (val) {
        case 1:
          return "坑口价";
        case 2:
          return "出厂价";
        case 3:
          return "到港价";
        case 4:
          return "平仓价";
        case 5:
          return "车板价";
        case 6:
          return "到厂价";
      }
    },
    /** 价格展示:多商品显示"详情查看价格信息",0 元显示"￥面议" */
    priceFilter(val) {
      if (val.length > 1) return "详情查看价格信息";
      if (val[0].goodsPrice == 0) return "￥面议";
      return `${val[0].goodsPrice}`;
    },
    /** 竞价状态码转文案:0 未开始,1 进行中,2 已流拍,3 有中标,4 已取消 */
    goodsStatus(val) {
      switch (val) {
        case 0:
          return "未开始";
        case 1:
          return "进行中";
        case 2:
          return "已流拍";
        case 3:
          return "有中标";
        case 4:
          return "已取消";
      }
    },
  },
  computed: {
    /** 当前选中的合作平台平台配置 */
    currentConfig() {
      return PLATFORM_CONFIG[this.currentPlatform.toUpperCase()];
    },
    ...mapState({
      /** 访问令牌 */
      token: state => state.token,
      /** 刷新令牌 */
      refreshToken: state => state.refreshToken,
      /** 用户权限 */
      permission: state => state.user.permission,
      /** 登录/认证状态文案 */
      massage: state => state.user.massage,
    }),
    /** 拼接商品指标摘要(名称+符号+数值+单位,逗号分隔) */
    computedQuotas() {
      return val => {
        if (val.length == 0) return "";
        let quotaValue = "";
        val.forEach(item => {
          if (item.quotas?.length) {
            item.quotas.forEach(quota => {
              quotaValue +=
                quota.name +
                quota.unit.split(";")[2] +
                quota.value +
                quota.unit.split(";")[1] +
                ",";
            });
          }
        });
        return quotaValue;
      };
    },
    /** 是否已登录且企业认证通过(控制中标公告侧栏显示) */
    computedLoginAndAuthentication() {
      let status = this.massage == "未登录请前往登录" || this.massage == "请前往认证后操作";
      return !status;
    },
  },

  methods: {
    /** 价格指数表格点击:type=2 时切换全屏弹窗显隐 */
    tableClick(priceIndexType) {
      if (this.isShow && priceIndexType == 2) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    /** 获取终端采购招标公示列表(首页 6 条) */
    getIBlist() {
      let config = {
        pageSize: 6,
        pageNum: 1,
      };

      getinquiryBulletinPage(config).then(res => {
        if (res.code == 0) {
          this.inquiryBulletinList = res.data.list;
        }
      });
    },
    /** 获取首页滚动文字列表,并在首位插入交易统计卡片标记 */
    sysRotateTextList() {
      let config = {
        ifOpen: 0,
        pageSize: 10,
        pageNum: 1,
      };
      sysRotateTextList(config).then(res => {
        if (res.code == 0) {
          let list = res.data.list;
          // list[0].src = require("../../assets/home_img/1.png");
          let newdata = {
            src: require("../../assets/home_img/1.png"),
          };
          list.unshift(newdata);
          this.TextList = res.data.list;
        }
      });
    },
    /** 运费计算入口:跳转铁路运费页 */
    freightEntrance() {
      this.$router.push({
        path: "/railway",
        query: {
          type: 1,
        },
      });
    },

    /** 中标公告侧栏 tab 切换 */
    activeClick(e) {
      this.InActive = e;
    },
    /** 挂牌交易 tab 切换:1 显示销售列表,2 显示采购列表 */
    handleSelect(key) {
      this.activeIndex = key;
      // this.salesList
      // purchaseList 采购
      if (key == 1) {
        this.gplist = this.salesList;
      } else {
        this.gplist = this.purchaseList;
      }
    },
    /** 竞价交易 tab 切换:1 竞价销售,2 竞价采购,3 物流竞价 */
    handleSelects(key) {
      // 1:salesList       1  1
      // 2:purchaseList     1 2
      this.activeIndexs = key;
    },

    // 查询交易预告列表
    async getTransactionNoticelist() {
      const res = await getTradeGoods4NoticeAlist({});
      if (res.code == 0) {
        this.transactionNoticeListAll = res.data || {};
        this.handleSelectTransaction(this.transactionNoticeTabsList[0], 0);
      } else {
        this.$message.error(res.msg);
      }
    },

    // 交易预告 - tabs切换
    handleSelectTransaction(item, key, auto = false) {
      this.transactionCurrent = key; // 当前高亮
      this.transactionNoticeList = this.transactionNoticeListAll[item.platformType].records
        .map(item => {
          return {
            ...item,
            timeYear: item.time.slice(0, 4),
            timeMMDD: item.time.slice(5, 10),
          };
        })
        .slice(0, 6);
      // 5s 轮询
      if (!auto) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.transactionCurrent < this.transactionNoticeTabsList.length - 1) {
            this.transactionCurrent++;
          } else {
            this.transactionCurrent = 0;
          }
          this.handleSelectTransaction(
            this.transactionNoticeTabsList[this.transactionCurrent],
            this.transactionCurrent,
            true,
          );
        }, 5000);
      }
    },

    // 交易预告 - 跳转查看详情
    totransactionNoticedeatil(item) {
      // 新疆 - 当前页面跳转
      if (this.transactionCurrent === 0) {
        location.href = item.url;
      } else {
        // 其他地区 - 打开新页面
        window.open(item.url);
      }
    },

    // 交易预告 - tab切换 - 查看更多按钮
    goToMore() {
      // 新疆
      if (this.transactionCurrent === 0) {
        this.$router.push({
          path: "/mall",
          query: {
            selectTradeType: 2,
            selectOrderType: 1,
          },
        });
      }
      if (this.transactionCurrent === 1) window.open("https://www.ctctc.cn/"); // 太原
      if (this.transactionCurrent === 2) window.open("https://www.westcoal.com.cn/"); // 陕西
      if (this.transactionCurrent === 3) window.open("https://nmgctc.com.cn/"); // 内蒙古
      if (this.transactionCurrent === 4) window.open("https://www.gn580.cn/platform-website/home"); // 国能
    },

    /** 通用获取合作平台数据方法 */
    async fetchPlatformData(platformKey) {
      const config = PLATFORM_CONFIG[platformKey.toUpperCase()];
      if (!config) return [];

      try {
        const res = await config.api({ pageNum: 1, pageSize: 6 });
        const data = res[config.dataPath] || {};
        const total = data[config.totalKey] || 0;

        if (total <= 0) return [];

        const list = data[config.listKey] || [];
        return list.map(item => ({
          ...item,
          timeYear: moment(item[config.timeKey]).format("YYYY"),
          timeMMDD: moment(item[config.timeKey]).format("MM-DD"),
          // 添加平台标识，便于识别
          platformType: platformKey,
        }));
      } catch (error) {
        console.error(`获取${config.name}数据失败:`, error);
        return [];
      }
    },

    /** 查询合作平台交易预告列表 */
    async getCooperationList() {
      const [taomeiData, zhongmeiData] = await Promise.all([
        this.fetchPlatformData("taomei"),
        this.fetchPlatformData("zhongmei"),
      ]);

      this.platformData.taomei = taomeiData;
      this.platformData.zhongmei = zhongmeiData;

      // 构建tabs列表
      this.buildCooperationTabs();

      // 设置默认展示数据
      this.setDefaultDisplay();
    },

    /** 合作平台交易预告 - tabs配置 */
    buildCooperationTabs() {
      const tabs = [];
      if (this.platformData.taomei.length > 0) {
        tabs.push({ name: "淘煤网", value: 0, key: "taomei" });
      }
      if (this.platformData.zhongmei.length > 0) {
        tabs.push({ name: "中煤商务", value: 1, key: "zhongmei" });
      }
      this.cooperationTabsList = tabs;
    },

    /** 设置默认展示数据 */
    setDefaultDisplay() {
      if (this.cooperationTabsList.length === 0) {
        this.cooperationList = [];
        return;
      }

      // 默认选择第一个有数据的平台
      const defaultPlatform = this.cooperationTabsList[0].key;
      this.currentPlatform = defaultPlatform;
      this.cooperationList = this.platformData[defaultPlatform] || [];
    },

    /** 跳转合作平台交易预告列表 */
    goToCooperation() {
      // 如果有多个tab，使用当前选中的平台
      if (this.cooperationTabsList.length > 1) {
        const config = this.currentConfig;
        if (config) {
          window.open(config.listUrl);
        }
        return;
      }

      // 只有一个tab时，直接跳转
      if (this.cooperationTabsList.length === 1) {
        const config = PLATFORM_CONFIG[this.cooperationTabsList[0].key.toUpperCase()];
        if (config) {
          window.open(config.listUrl);
        }
        return;
      }
    },
    /** 合作平台交易预告 - tabs 切换 */
    handleSelectCooperation(item) {
      const platformKey = item.key;
      this.currentPlatform = platformKey;
      this.cooperationList = this.platformData[platformKey] || [];
    },
    /** 合作平台交易预告 - 跳转查看详情 */
    toCooperationDeatil(url) {
      window.open(url);
    },

    ...mapActions([types.GET_TOKEN]),
    // 权限操作
    /** 权限操作:无 token 标记未登录,有 token 校验企业认证状态 */
    jurisdiction() {
      window.localStorage.setItem("massage", "");
      let token = window.localStorage.getItem("token");
      if (!token) {
        window.localStorage.setItem("massage", "未登录请前往登录");
      } else {
        this.everything();
      }
    },
    /** 物流竞价行点击:发布者进管理详情页,其他进普通详情页 */
    ItemClicks(item) {
      if (this.userId == item.publisherId) {
        this.$router.push({
          path: "/logisticsDetailss",
          query: {
            goodsId: item.goodsId,
          },
        });
      } else {
        this.$router.push({
          path: "/logisticsDetails",
          query: {
            goodsId: item.goodsId,
          },
        });
      }
    },

    /** 竞价/采购表格行点击:跳转商品详情 */
    ItemClick(item) {
      this.$router.push({
        path: "/goodsDetail",
        query: {
          goodsId: item.goodsId,
          selectTradeType: item.tradeType,
          selectOrderType: item.orderType,
        },
      });
    },

    /** 跳转采购招标公示列表页 */
    inquiryBulletinClick() {
      this.$router.push({
        path: "/inquiryBulletin",
      });
    },
    /** 查询当前用户企业认证状态并写入 localStorage(massage) */
    async everything() {
      await getqxshuju().then(res => {
        if (res.code == 0) {
          if (res.data) {
            res.data.auditStatus !== 1 && res.data.auditStatus !== -1 && res.data.auditStatus !== 2
              ? window.localStorage.setItem("massage", "您的企业信息正在审核中请耐心等待")
              : res.data.auditStatus == -1 || res.data.auditStatus == 2
              ? window.localStorage.setItem("massage", "请前往认证后操作")
              : "";
          } else {
            window.localStorage.setItem("massage", "请前往认证后操作");
          }
        }
      });
    },
    /** 跳转物流竞价列表页 */
    tomallClick() {
      this.$router.push({
        path: "/LogisticsBidding",
      });
    },
    /** 跳转邀约信息列表页 */
    InvitationClick() {
      this.$router.push({
        path: "/Invitation",
        query: {
          type: 3,
        },
      });
    },
    /** 邀约交易卡片详情:需登录,暂存条目后跳转邀约详情页 */
    otherdetail(item) {
      // console.log(item);
      // 步骤一:校验登录
      let enterpriseId = Vue.ls.get(types.enterpriseId);
      if (!enterpriseId) {
        this.$message({
          message: "请先登录",
          type: "error",
        });
      } else {
        // 步骤二:暂存条目并携带参数跳转邀约详情页
        Vue.ls.set("ItemOn", item);
        this.$router.push({
          path: "/InvitationDetailed",
          query: {
            goodsName: item.goodsName,
            goodsNum: item.goodsNum,
            receiverName: item.receiverName,
            receiverTelephone: item.receiverTelephone,
            taxIncluded: item.taxIncluded,
            priceType: item.priceType,
            listingPrice: item.listingPrice,
            initialCount: item.initialCount,
            goodsId: item.goodsId,
            // fileId: item.contractInfoList[0].fileId,
            confirmStatus: item.confirmStatus,
            inviteEnterpriseId: item.inviteEnterpriseId,
            notes: "other",
            viewSet: JSON.stringify(item.viewSet),
            ifConsultRealityCount: item.ifConsultRealityCount,
          },
        });
      }
    },
    /** 跳转挂牌商城列表(订单类型固定取当前挂牌 tab) */
    tomall(selectTradeType, selectOrderType) {
      selectOrderType = this.activeIndex;
      this.$router.push({
        path: "/mall",
        query: {
          selectTradeType,
          selectOrderType,
        },
      });
    },
    /** 竞价区"查看更多":tab 1/2 跳商城,3 跳物流竞价列表 */
    tomalls() {
      if (this.activeIndexs != 3) {
        let selectOrderType = this.activeIndexs;
        this.$router.push({
          path: "/mall",
          query: {
            selectTradeType: 2,
            selectOrderType,
          },
        });
      } else {
        this.$router.push({
          path: "/LogisticsBidding",
        });
      }
    },
    /** 跳转商品详情页 */
    todetail(id, a, b) {
      this.$router.push({
        path: "/goodsDetail",
        query: {
          goodsId: id,
          selectTradeType: a,
          selectOrderType: b,
        },
      });
    },
    /** token 初始化:未登录游客获取访问令牌,已登录直接初始化首页数据 */
    async gettoken() {
      const userId = Vue.ls.get(types.userId);
      // console.log(userId);
      // 未登录:以游客身份获取令牌
      if (!userId) {
        let config = {
          grant_type: "init",
          client_id: "xjcec",
          client_secret: "xjcec_secret",
          scope: "all",
        };
        await reqGetToekn(config).then(res => {
          if (res.code == 0) {
            Vue.ls.set(types.ACCESS_TOKEN, res.data.accessToken);
            Vue.ls.set(types.REFRESH_TOKEN, res.data.refreshToken);
            // Vue.ls.set(types.checkUkeyWhite, res.data.checkUkeyWhite);
            Vue.ls.set(types.EXPIRES_IN, res.data.expiresTime + "000");
            // let token = Vue.ls.get("token")
            this.initialization();
          }
        });
      } else {
        // 已登录:直接初始化首页数据
        this.initialization();
      }
    },
    /** 合作伙伴外链跳转(新窗口) */
    toPartner(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    /** 跳转公告列表页 */
    toannouncement(type) {
      this.$router.push({
        path: "/announcement",
        query: {
          type,
        },
      });
    },
    /** 跳转竞价销售列表 */
    JCXSClick() {
      this.$router.push({
        path: "/mall",
        query: {
          selectTradeType: 2,
          selectOrderType: 1,
        },
      });
    },
    /** 跳转挂牌销售列表 */
    GPXSlick() {
      this.$router.push({
        path: "/mall",
        query: {
          selectTradeType: 1,
          selectOrderType: 1,
        },
      });
    },
    /** 跳转挂牌采购列表 */
    GPCGclick() {
      this.$router.push({
        path: "/mall",
        query: {
          selectTradeType: 1,
          selectOrderType: 2,
        },
      });
    },
    /** 跳转竞价采购列表 */
    JJCGClick() {
      this.$router.push({
        path: "/mall",
        query: {
          selectTradeType: 2,
          selectOrderType: 2,
        },
      });
    },
    /** 跳转公告详情页(定向中标公告先校验登录认证与查看权限) */
    tobiddingdeatil(type, item) {
      // 中标公告(messageType == 2)先校验是否定向竞价
      if (type == "win" && item.messageType == 2) {
        reqBiddingTargeted(item.businessId).then(res => {
          if (res.code != 0) {
            // 接口异常:展示后端返回信息
            this.$message(res.message);
            return;
          }
          /** biddingTargeted 是否定向竞价：0不开启 1开启
           * partiesFlag 是否参与方：0不是 1是
           */
          // 未开启定向竞价:公开公告,直接跳转
          if (res.data.biddingTargeted != 1) {
            this.$router.push({
              path: "/biddingdeatil",
              query: {
                type,
                messageId: item.messageId,
                businessId: item.businessId,
              },
            });
            return;
          }
          // 开启定向竞价:先校验登录与认证
          if (!this.beforhandle("all")) return;
          // 已登录已认证:再看是否为参与方
          if (res.data.partiesFlag == 1) {
            // 有权限,跳转公告详情
            this.$router.push({
              path: "/biddingdeatil",
              query: {
                type,
                messageId: item.messageId,
                businessId: item.businessId,
              },
            });
          } else {
            // 定向竞价非参与方
            this.$message.error("对不起,您还未获得该场次中标公告的查看权限");
          }
        });
        return;
      }
      // 其他公告直接跳转
      this.$router.push({
        path: "/biddingdeatil",
        query: {
          type,
          messageId: item.messageId,
          businessId: item.businessId,
        },
      });
    },
    /** 跳转新闻详情页 */
    tojournalism(id) {
      this.$router.push({
        path: "/journalism",
        query: {
          id,
        },
      });
    },
    /** 校验字符串是否为合法 JSON */
    isJSON(str) {
      if (typeof str == "string") {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      }
    },
    /** 日期格式化为 [MM-DD] */
    tommdd(data) {
      return "[" + data.split("T")[0].split("-")[1] + "-" + data.split("T")[0].split("-")[2] + "]";
    },
    /** 首页数据初始化总入口:依次拉取各模块数据 */
    async initialization() {
      // 步骤一:采购招标公示列表
      this.getIBlist();

      const that_ = this;

      // 步骤二:轮播图(解析 dictValue JSON 拼接图片地址,无数据时用默认图)
      const res = await getbannerList({
        dictType: "banner_trade",
        pageNum: 0,
        pageSize: 5,
        bannerPosition: 1,
      });
      if (res.code == 0) {
        this.bannerList = [];
        if (res.data?.list?.length) {
          res.data.list.forEach(item => {
            let obj = {};
            if (that_.isJSON(item.dictValue)) {
              obj = JSON.parse(item.dictValue);
              obj.banner_img = baseUrl + "third/third/ossGetFile/" + obj.banner_img;
              this.bannerList.push(obj);
            }
          });
        } else {
          let list = [];
          list.push({
            banner_name: " ",
            banner_img: require("@/assets/home_img/123.png"),
            jump_url: "",
          });
          this.bannerList = list;
        }
      }

      // 步骤三:按域名判定区域(北疆站限定产地与字典标签)
      let a = document.URL;
      var str1 = a.substring(0, a.indexOf("#"));
      let originPlace = "";
      let dictLabel = null;
      if (str1 == "https://north.xjcec.com/") {
        originPlace = "新疆维吾尔族自治区,伊犁哈萨克自治州";
        dictLabel = 1;
      } else {
        originPlace = "";
        dictLabel = 0;
      }
      // 步骤四:交易统计(累计交易量/成交额)
      const gmv = await gmvdetail({
        enterpriseName: "",
        originPlace: originPlace,
      });
      if (gmv.code == 0) {
        // console.log(gmv,'gmv');
        //totalCount累计交易量 totalPrice	//累计成交额
        this.gmv = gmv.data;
      }
      // 步骤五:挂牌销售列表(拼接商品指标 title)
      const Sales = await nominal({
        size: 6,
        page: 1,
        releaseDateOrderBy: 1,
        selectTradeType: 1,
        selectOrderType: 1,
        endFlag: false,
        originPlace: originPlace,
      });
      if (Sales.code == 0) {
        let list = Sales.data.records;
        list.forEach(item => {
          let a = [];

          if (item.quotas) {
            let quotas = item.quotas;
            quotas.forEach(items => {
              a.push(
                items.name + items.unit.split(";")[2] + items.value + items.unit.split(";")[1],
              );
            });
          }
          item.title = a.toString();
        });
        // this.gplist = list;
        this.salesList = list;
      }
      // 步骤六:邀约交易列表
      const Invite = await listTradeInvite({
        pageSize: 6,
        pageNum: 1,
        searchType: 3,
        enterpriseId: Vue.ls.get(types.enterpriseId),
      });
      if (Invite.code == 0) {
        this.InviteList = Invite.data.list;
        // console.log(this.InviteList);
      }
      // 步骤七:挂牌采购列表(拼接商品指标 title)
      const purchase = await nominal({
        size: 6,
        page: 1,
        releaseDateOrderBy: 1,
        selectTradeType: 1,
        selectOrderType: 2,
        endFlag: false,
        originPlace: originPlace,
      });
      if (purchase.code == 0) {
        let list = purchase.data.records;
        list.forEach(item => {
          let a = [];
          if (item.quotas) {
            let quotas = item.quotas;
            quotas.forEach(items => {
              a.push(
                items.name + items.unit.split(";")[2] + items.value + items.unit.split(";")[1],
              );
            });
          }
          item.title = a.toString();
        });
        this.purchaseList = list;
        // this.purchaseList = purchase.data.records;
        // console.log(this.salesList,'salesList')
      }
      // 步骤八:竞价销售列表(状态码转文案,价格/数量按商品拼接)
      const biddingX = await nominal({
        size: 50,
        page: 1,
        // releaseDateOrderBy: 1,
        ifHomePage: true,
        selectTradeType: 2,
        selectOrderType: 1,
        endFlag: false,
        originPlace: originPlace,
      });
      if (biddingX.code == 0) {
        let list = biddingX.data.records;
        for (let i = 0; i < list.length; i++) {
          if (list[i].goodsStatus == 0) {
            list[i].goodsStatus = "未开始";
          }
          if (list[i].goodsStatus == 1) {
            list[i].goodsStatus = "进行中";
          }
          if (list[i].goodsStatus == 2) {
            list[i].goodsStatus = "已流拍";
          }
          if (list[i].goodsStatus == 3) {
            list[i].goodsStatus = "有中标";
          }
          if (list[i].goodsStatus == 4) {
            list[i].goodsStatus = "已取消";
          }
        }
        this.biddingXList = list.map(item => {
          item.price = item.goodsCategoryList.reduce((per, cur, index) => {
            return per + (cur.goodsPrice + (index == item.goodsCategoryList.length - 1 ? "" : ","));
          }, "");
          item.stockCount = item.goodsCategoryList.reduce((per, cur, index) => {
            return per + (cur.number + (index == item.goodsCategoryList.length - 1 ? "" : ","));
          }, "");
          return item;
        });
        console.log(this.biddingXList);
        // this.biddingXList = biddingX.data.records.map((item) => {
        //   return {
        //     ...item,
        //     //        switch (val) {
        //     //   case 0:
        //     //     return "未开始";
        //     //     break;
        //     //   case 1:
        //     //     return "进行中";
        //     //     break;
        //     //   case 2:
        //     //     return "已流拍";
        //     //     break;
        //     //   case 3:
        //     //     return "有中标";
        //     //     break;
        //     //   case 4:
        //     //     return "已取消";
        //     //     break;
        //     // }
        //     goodsStatus:item.goodsStatus == 0 ? "未开始": item.goodsStatus == 1? "进行中" : "已结束",

        //     // goodsStatus:
        //     //   item.goodsStatus == 0
        //     //     ? "未开始"
        //     //     : item.goodsStatus == 1
        //     //       ? "进行中"
        //     //       : "已结束",
        //   };
        // });
        // console.log(this.salesList,'salesList')
      }
      // 步骤九:竞价采购列表(状态码转文案,价格/数量按商品拼接)
      const biddingT = await nominal({
        size: 50,
        page: 1,
        ifHomePage: true,
        selectTradeType: 2,
        selectOrderType: 2,
        endFlag: false,
        originPlace: originPlace,
      });
      if (biddingT.code == 0) {
        let list = biddingT.data.records;
        for (let i = 0; i < list.length; i++) {
          if (list[i].goodsStatus == 0) {
            list[i].goodsStatus = "未开始";
          }
          if (list[i].goodsStatus == 1) {
            list[i].goodsStatus = "进行中";
          }
          if (list[i].goodsStatus == 2) {
            list[i].goodsStatus = "已流拍";
          }
          if (list[i].goodsStatus == 3) {
            list[i].goodsStatus = "有中标";
          }
          if (list[i].goodsStatus == 4) {
            list[i].goodsStatus = "已取消";
          }
        }
        this.biddingTList = list.map(item => {
          item.price = item.goodsCategoryList.reduce((per, cur, index) => {
            return per + (cur.goodsPrice + (index == item.goodsCategoryList.length - 1 ? "" : ","));
          }, "");
          item.stockCount = item.goodsCategoryList.reduce((per, cur, index) => {
            return per + (cur.number + (index == item.goodsCategoryList.length - 1 ? "" : ","));
          }, "");
          return item;
        });
      }
      // 步骤十:物流竞价列表(状态码转文案,时间格式化)
      const biddingS = await listTbGoods({
        pageSize: 50,
        pageNum: 1,
        sourcePage: 1 /** 来源页面 1 首页模块  2 列表 */,
      });
      if (biddingS.code == 0) {
        let list = biddingS.data.list;
        for (let i = 0; i < list.length; i++) {
          if (list[i].biddingStatus == 0) {
            list[i].biddingStatus = "未开始";
          }
          if (list[i].biddingStatus == 1) {
            list[i].biddingStatus = "进行中";
          }
          if (list[i].biddingStatus == 2) {
            list[i].biddingStatus = "已流拍";
          }
          if (list[i].biddingStatus == 3) {
            list[i].biddingStatus = "有中标";
          }
          if (list[i].biddingStatus == 4) {
            list[i].biddingStatus = "已取消";
          }

          if (list[i].biddingStartTime) {
            list[i].biddingStartTime = list[i].biddingStartTime.replace("T", " ");
          }
          if (list[i].biddingEndTime) {
            list[i].biddingEndTime = list[i].biddingEndTime.replace("T", " ");
          }
        }
        this.logisticsList = list;
      }

      // 步骤十一:合作伙伴(解析 dictValue JSON 拼接图片与跳转地址)
      const partner = await getpartnerList({
        dictType: "partner",
        pageNum: 1,
        pageSize: 12,
        dictLabel: dictLabel,
      });
      if (partner.code == 0) {
        this.partnerList = [];
        partner.data.list.map(item => {
          if (that_.isJSON(item.dictValue)) {
            let obx = JSON.parse(item.dictValue);
            item.partner_img = baseUrl + "third/third/ossGetFile/" + obx.partner_img;
            item.jump_url = obx.jump_url;
            this.partnerList.push(item);
          }
        });
      }
      // 步骤十二:三类公告(竞价/物流/中标,时间格式化)
      const bidding = await biddingList({
        messageType: 1,
        page: 1,
        size: 4,
      });
      if (bidding.code == 0) {
        this.biddingList = bidding.data.records.map(item => {
          return {
            ...item,
            createTime: this.tommdd(item.createTime),
          };
        });
      }

      const biddings = await biddingList({
        messageType: 3,
        page: 1,
        size: 4,
      });
      if (biddings.code == 0) {
        this.BiddingNotice = biddings.data.records.map(item => {
          return {
            ...item,
            createTime: this.tommdd(item.createTime),
          };
        });
      }

      const win = await biddingList({
        messageType: 2,
        page: 1,
        size: 4,
      });
      if (win.code == 0) {
        this.winList = win.data.records.map(item => {
          return {
            ...item,
            createTime: this.tommdd(item.createTime),
          };
        });
        // console.log(this.winList,'this.winList');
      }
      // 步骤十三:滚动文字、交易预告、合作平台预告
      this.sysRotateTextList();
      // 获取交易预告列表
      this.getTransactionNoticelist("XJ");
      /** 获取合作平台交易预告列表 */
      this.getCooperationList();
    },

    /** 打开外链(无协议时补 http://,新窗口) */
    open(url) {
      if (url) {
        url.indexOf("http") == -1
          ? window.open("http://" + url, "_blank")
          : window.open(url, "_blank");
      }
    },
    /** 导航菜单跳转(当前未使用) */
    toOtherPage(data) {
      this.checked = data.title;
      this.$router.push({
        path: data.path,
        query: data.query ? data.query : {},
      });
    },

    /** 打开采购招标公示详情弹窗 */
    openInquiryBulletinDetail(row) {
      this.$refs.inquiryBulletinDetail.openDialog(row);
    },
    // handleScroll() {
    //   const scrollTop =
    //     window.pageYOffset || document.documentElement.scrollTop;
    //   if (scrollTop > this.stickyOffset) {
    //     this.isSticky = true;
    //   } else {
    //     this.isSticky = false;
    //   }
    // },
  },
  /** 清除交易预告定时器 */
  beforeDestroy() {
    // window.removeEventListener("scroll", this.handleScroll);
    // 清除交易预告定时器
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.text_weight_500 {
  font-weight: 500;
}

.text_weight_600 {
  font-weight: 600;
}

.font-size_16 {
  font-size: 16px;
}
.font-size_18 {
  font-size: 18px;
}

.font-size_20 {
  font-size: 20px;
}

.font-size_24 {
  font-size: 24px;
}

.font-size_26 {
  font-size: 26px;
}

.font-size_28 {
  font-size: 28px;
}

.font-size_30 {
  font-size: 30px;
}

.font-size_32 {
  font-size: 32px;
}

.right-sticky {
  position: fixed;
  left: 100px;
  z-index: 995;
  bottom: 10px;
}
.list_listall {
  position: relative;

  .right-info {
    background-size: contain;
    cursor: pointer;

    .right-info-check {
      margin-top: 4px;
      font-size: 10px;
      color: #999;
    }
    .right-info-text {
      font-size: 10px;
    }
    .right-info-title {
      display: inline-block;
      font-size: 14px;
      .line {
        height: 6px;
        width: 100%;
        border-radius: 3px;
        background: linear-gradient(to right, rgba(54, 123, 248, 0.54), rgba(107, 177, 255, 0.54));
        margin-top: -6px;
      }
    }
  }
  .right-freight {
    padding: 16px;
    width: 100px;
    height: 120px;
    background: url("../../assets/home_img/freight.png");
    margin-top: 15px;
    background-size: contain;
  }
  .right-qr-code {
    padding: 10px;
    width: 101px;
    height: 141px;
    background: url("../../assets/home_img/qr-code-bg.png");
    background-size: contain;
    img {
      width: 76px;
      height: 69px;
      margin-left: 3px;
    }
  }
}
.actives {
  // background-color: #7343d1;
  color: rgba(255, 255, 255, 0.75);
  padding: 15px 16px;
  display: flex;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
  cursor: pointer;
}

.active_2 {
  width: 100%;
  background-color: rgb(115, 67, 209);
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  padding: 15px 16px;
  display: flex;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
  cursor: pointer;
}

.info-left {
  .f-hide {
    & + .f-hide {
      margin-top: 5px;
    }
  }
}

.list_box:after {
  content: "";
  width: 378px;
  height: 0;
  visibility: hidden;
}

.list_box {
  display: flex;
  // justify-content:start;
  justify-content: space-between;

  /* justify-content: flex-start; */
  flex-wrap: wrap;
  /* padding: 16px 20px; */
  padding-bottom: 0;

  .items {
    border: 1px solid #fff;
    background: #fff;
    min-width: 370px;
    width: 370px;
    // height: 156px;
    padding: 16px;
    margin-top: 10px;

    // background: linear-gradient(-45deg, #00A0FF, #0A65FF);
    // box-shadow: 0px 5px 20px 0px rgba(143, 170, 249, 0.47);
    border-radius: 10px;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      margin-top: 3px;
    }
    /* &:hover {
      background: linear-gradient(-45deg, #00a0ff, #0a65ff);
      color: white;
    } */
    // &:nth-child(3n) {
    //   margin-right: 0 !important;
    // }

    /* &:hover {
      border: 1px solid #2084d6;
    } */
    .item-title {
      font-size: 12px;
      font-weight: bold;
      // padding-bottom: 10px;
      margin-top: 12px;
      align-items: center;
      /* border-bottom: 1px solid #e5e5e5; */
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 13px 3px;

      /* p {
        width: 150px;
      } */
      .price {
        flex-shrink: 0;
      }
    }

    .origin {
      margin-top: 10px;
    }
  }

  .list_box_items {
    width: 559px;
    height: 100px;
    border: 1px solid #fff;
    background: #fff;
    padding: 16px;
    margin-top: 10px;
    border-radius: 10px;
    cursor: pointer;

    .list_item_content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      color: #333333;

      .text_span {
        color: #999999;
      }

      .line {
        width: 1px;
        height: 72px;
        background: linear-gradient(180deg, #ffffff 0%, #dbeddd 50%, #ffffff 100%);
        margin: 0 35px 0 30px;
      }
    }
  }
  .item_title {
    width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }

  .list_box_items-taomei {
    width: 560px;
    height: 72px;
    background: #fff;
    padding: 24px 23px;
    margin-top: 15px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.el-table__header tr,
.el-table__header th {
  padding: 0 !important;
  height: 42px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #333333 !important;
}

.el-table__body tr,
.el-table__body td {
  padding: 0 !important;
  height: 42px !important;
}
</style>
<style lang="scss" scoped>
.image-slot {
  height: 100%;
  width: 100%;
}

.error_img {
  height: 100%;
  width: 100%;
  /* background: url("../../assets/img/banner.jpg"); */
  background-size: 100% 100%;
}

.partner_title {
  padding-top: 50px;
  text-align: left;
  font-size: 26px;
  font-weight: 500;
}

.partner_title2 {
  width: 263px;
  margin-top: 20px;
  text-align: left;
  line-height: 25px;
}

.flx_space {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.menu_box {
  background: rgb(255, 255, 255);
  position: fixed;
  top: 124px;
  z-index: 999;
  width: 100%;
}

::v-deep .el-carousel--horizontal {
  overflow-x: initial;
}

::v-deep .el-carousel {
  overflow: hidden;
}

.flex_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: #fff; */
  height: 48px;
  align-items: baseline;
}

.index {
  width: 100%;

  // 轮播图
  .banner {
    min-width: 1903px;
    position: relative;
    width: 100%;
    .indicator {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      left: 50%;
      bottom: 0;
      width: 1200px;
      height: 80px;
      z-index: 9999999;
      transform: translate(-50%, 50%);
      background-color: #fff;
      border: 1px solid #000;
    }
  }

  // 交易量
  .business {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // width: 100%;
    // min-width: 1903px;
    // background: url("../../assets/home_img/2.png") no-repeat;
    // background-size: 100% 100%;
    .itemAll {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }

    .business_item {
      display: flex;
      align-items: center;

      .item_img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 104px;
        height: 104px;
        border-radius: 50%;
        margin-left: 81px;
      }

      .inner {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 73px;
        margin-left: 28px;

        .num {
          font-size: 38px;
          font-weight: bold;

          .mini {
            font-size: 26px;
          }
        }
      }
    }
  }

  // 销售列表
  .market_list {
    // margin-top: 20px;
    width: 1440px;
    display: flex;

    .list-content {
      height: 335px;
      overflow: hidden;
    }

    .list_box {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      // height: 100%;

      .every_box {
        background-color: #fff;
        padding: 14px 0;
        // height: 156px;
        box-shadow: 0px 5px 20px 0px rgba(143, 170, 249, 0.47);
        border-radius: 10px;
        width: calc(calc(100% / 3) - 22px);

        .header {
          padding: 0 20px;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          border-bottom: 1px solid #dddddd;
          padding-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .body {
          margin: 0;
          color: #333333;
        }

        .foot {
          font-size: 12px;
          margin-top: 13px;
          padding: 0 20px;
          color: #999999;

          .onespan {
            display: inline-block;
            width: 337px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .mianyi {
          font-size: 20px;
          color: #fe7b35;
        }

        &:hover .mianyi {
          color: #fff100;
        }

        &:hover .body {
          color: #ffffff;
        }

        &:hover .header {
          color: #ffffff;
        }

        &:hover .foot {
          color: #ffffff;
        }
      }

      .every_box:hover {
        color: #fff;
        background: linear-gradient(125deg, #00a0ff, #0a65ff);
      }
    }

    /* .list_box :nth-child(n + 4) {
      margin-top: 22px;
    } */
  }

  .headbox {
    // width: 1142px;
    height: 48px;
    padding: 0 30px;
    background: #fff;
    align-items: baseline;
    border-radius: 8px;
  }

  .boder_bottom {
    display: flex;
    font-size: 16px;
    color: #333333;
    line-height: 42px;
  }

  .more {
    font-size: 15px;
    font-weight: bold;
    color: #4861fe;
    /* padding-top: 30px; */
  }

  .mores {
    font-size: 15px;
    font-weight: bold;
    color: #7937fe;
  }

  .click_more {
    color: #5f75fe;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    line-height: 48px;
  }

  // 销售
  .market {
    width: 1440px;
    display: flex;
    // position: relative;
    // & > .right-freight {
    //   position: absolute;
    //   top: 0;
    //   width: 100px;
    //   height: 120px;
    //   right: -120px;
    //   background: url("../../assets/home_img/freight.png");
    //   background-size: contain;
    //   cursor: pointer;
    //   padding: 16px;
    //   .freight-check {
    //     margin-top: 4px;
    //     font-size: 10px;
    //     color: #999;
    //   }
    //   .freight-title {
    //     display: inline-block;
    //     font-size: 14px;
    //     .line {
    //       height: 6px;
    //       width: 100%;
    //       border-radius: 3px;
    //       background: linear-gradient(
    //         to right,
    //         rgba(54, 123, 248, 0.54),
    //         rgba(107, 177, 255, 0.54)
    //       );
    //       margin-top: -6px;
    //     }
    //   }
    // }
    .market_left {
      width: 100%;
    }

    .market_right {
      width: 100%;
      /* box-shadow: 10px 10px 5px #f1f1f1; */
      background: #fd5b4c;
      color: #fff;
      padding: 20px;
    }

    .market_righton {
      width: 100%;
      /* box-shadow: -10px 10px 5px #f1f1f1; */
      /* padding-left: 10px; */
    }

    .data2 {
      width: 44px;
    }

    .title2 {
      text-align: left;
      width: 147px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  // 服务理念
  .service {
    // background: url("../../assets/img/kuanggong.jpg") no-repeat;
    background-size: cover;
    width: 100%;
    // height: 212px;
    margin-top: 20px;

    .service_box {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
    }

    .sercice_item {
      display: flex;
      width: calc(calc(100% / 3) - 20px);
      margin: 10px;
      align-items: center;
      justify-content: center;

      .img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #3ca9fc;
        background-image: url("../../assets/images/icon01.png");
      }

      .img2 {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #3ca9fc;
        background-image: url("../../assets/images/icon02.png");
      }

      .img3 {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #3ca9fc;
        background-image: url("../../assets/images/icon03.png");
      }

      .title {
        margin-left: 40px;
        height: 100px;
        padding-bottom: 6px;

        .one {
          font-size: 26px;
          font-weight: 400;
          color: #ffffff;
        }

        .two {
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }

  // 合作伙伴
  .partner_on {
    display: flex;
    width: 1440px;
    margin: 0 auto;
  }
  .partner_tw {
    width: 263px;
    margin-top: 20px;
  }
  .freight {
    width: 1440px;
    height: 120px;
    margin: 0 auto;
    margin-top: 20px;
    position: relative;
    background-size: 100% 100%;
    background-image: url("../../assets/images/freightEntrance.png");
    .freightImg {
      position: relative;
    }
    .freightButton {
      cursor: pointer;
      position: absolute;
      left: 51%;
      margin-top: 46px;
      top: 0;
      z-index: 999;
      color: white;
      border: 1px solid white;
      width: 100px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 10px;
    }
  }
  .partner {
    width: 100%;
    /* background-color: #ffffff; */
    background-image: url("../../assets/home_img/8.png");
    background-size: 100% 100%;
    margin-top: 28px;
    .panter_list {
      margin-left: 36px;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      justify-items: center;
      text-align: justify;
      padding: 55px 0;
      align-items: center;
      .partner_item {
        width: 180px;
        margin-top: 10px;
        margin-left: 10px;
        height: 72px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
  }
}
// .panter_list:after {content: ""; width: 560px; }
.home_menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  background: #ffffff;
  /* padding: 0 67px; */

  .home_menu_item {
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
  }

  .home_menu_item_action {
    font-size: 16px;
    cursor: pointer;
    font-weight: bold;
    color: #096aff;
  }
}

.blue_border {
  font-size: 20px;
  padding-bottom: 13px;
  /* border-bottom: 3px solid #3b76ff; */
}

.more_two {
  font-size: 16px;
  color: #fe7b35;
}

.more_tree {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  margin-top: 10px;
}
::v-deep .banner {
  .el-carousel__container {
    position: relative;
    width: 100%;
    height: 440px !important;
  }
}

::v-deep .el-carousel {
  position: relative;
}

::v-deep .el-table__body tr,
.el-table__body td {
  cursor: pointer;
}

.nodataImg {
  background: #fff;
  padding: 10px 0;
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-height: 150px;
  }
}
.nodata-img-height {
  margin-top: 15px;
  height: calc(100% - 15px);
}

.indicator_span {
  display: inline-block;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Listing {
  min-width: 284px;
  // height: 388px;
  background: url("../../assets/home_img/5.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 35px;
  color: white;
}
.Listingss {
  margin-right: 20px;
  min-width: 284px;
  // height: 384px;
  background: url("../../assets/home_img/10.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 35px;
  color: white;
}

.Listings {
  margin-right: 20px;
  // height: 422px;
  min-width: 284px;
  background: url("../../assets/home_img/4.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 35px;
  color: white;
}

.details-list {
  margin: 64px 0px 0px 0px;
  font-size: 18px;

  .details-list-dot {
    width: 8px;
    height: 8px;
    background: #ffffff;
    border-radius: 50%;
  }
}

.coopera-module {
  width: 1440px;
  height: 225px;
  display: flex;
}

.list-left {
  min-width: 284px;
  background: url("../../assets/home_img/11.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 35px;
  color: white;
  margin-right: 20px;
  height: 382px;
}

.list-left-taomei {
  min-width: 284px;
  background: url("../../assets/home_img/12.png") no-repeat;
  background-size: 100% 100%;
  padding: 45px 30px;
  margin-right: 20px;
  height: 382px;

  .details-list {
    margin-left: 5px;
  }
}

.btn_in {
  button {
    cursor: pointer;
    background: #4861fe;
  }
}
::v-deep {
  .Invitation {
    .active_on {
      font-weight: bold;
      color: #f48d0c;
      border-bottom: 2px solid #f48d0c;
    }
  }
}

.btn_ins {
  button {
    background: #fea638;
  }
}

::v-deep .boder_bottom {
  .el-menu {
    height: 48px !important;
    top: -28px;
    font-size: 14px !important;
  }

  .el-menu--horizontal > .el-menu-item {
    height: 47px;
  }
}

.gengduo {
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-rl;
  width: 32px;
  height: 105px;
  color: #7343d1;
  cursor: pointer;
  /* background: rgba(121, 55, 254, 1); */
  background-color: #f8f5ff;
  font-weight: 500;
  color: balck;
  /* padding-top: 15px; */
  /* margin: 12px; */
  margin-top: 12px;
  margin-left: 28px;
}

::v-deep .el-table .el-table__cell {
  padding: 7px 0;
}
::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  color: #409eff;
  font-size: 14px;
}
::v-deep .el-table th.el-table__cell {
  background: #f6f8fa;
}
::v-deep .el-table th.el-table__cell > .cell {
  background: #f6f8fa;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #999999;
  font-size: 16px;
  line-height: 20px;
  height: 28px;
  line-height: 28px;
}
// ::v-deep .el-table .cell {
//   font-family: PingFangSC-Medium, PingFang SC;
//   font-weight: 500;
//   color: rgba(0, 0, 0, 0.77);
//   white-space: nowrap;
// }
::v-deep .item_Op {
  font-weight: 600;
}
.active_on {
  border-bottom: 3px solid #4861fe;
  color: #4861fe;
  font-weight: 600;
}
.active_on_blue {
  border-bottom: 3px solid #02c282;
  color: #02c282;
  font-weight: 600;
}
.active_on_blue {
  border-bottom: 3px solid #3384ea;
  color: #3384ea;
  font-weight: 600;
}
.head_item {
  margin-right: 34px;
  cursor: pointer;
}
.caigou {
  margin-left: 34px;
  cursor: pointer;
}
.index_info {
  margin-top: 15px;
  width: 32px;
  height: 18px;
  background: #7343d1;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.index_infos {
  width: 203px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  margin-top: 11px;
  cursor: pointer;
}
.index_p {
  height: 40px;
  text-overflow: ellipsis;
  font-weight: 600;
  overflow: hidden;
}
.jingjia_in {
  width: 203px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  margin-top: 11px;
  cursor: pointer;
}
.jingjia_on {
  width: 32px;
  margin-top: 15px;
  height: 18px;
  background: #7343d1;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.messageCont {
  height: 40px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list_all {
  margin-left: 10px;
  display: flex;
  align-items: center;
}
.img_item {
  width: 100%;
  height: 440px;
}
.el-carousel__item h3 {
  color: black;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

::v-deep .TextClass {
  width: 100%;
  min-width: 1903px;
  background: url("../../assets/home_img/2.png") no-repeat;
  background-size: 100% 100%;
  .el-carousel__item h3 {
    line-height: 80px;
    text-align: center;
  }
}
.jiaoyi_c {
  margin-top: 12px;
  width: 162px;
  height: 28px;
  background: #f2f4ff;
  border-radius: 4px;
  line-height: 28px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #323232;
  padding-left: 14px;
}
.priceIndex-box {
  width: 1440px;
  display: flex;
  justify-content: space-between;
  margin: 20px auto 0;
  .priceIndex-box_left {
    width: 660px;
  }
  .priceIndex-box_right {
    width: 760px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    .purchase-price-table {
      width: 630px;
      height: 280px;
      .empty {
        height: 200px;
        background: url("../../assets/home_img/empty.png") no-repeat center;
        background-size: 161px 144px;
        padding-top: 110px;
      }
    }
    .purchase-price-left {
      cursor: pointer;
      width: 114px;
      height: 280px;
      background: url("../../assets/home_img/purchase-price.png");
      background-size: contain;
      padding-top: 34px;
      .purchase-title {
        width: 72px;
        margin: 0 auto;
        font-size: 18px;
        color: #fff;
      }
      .purchase-more {
        line-height: 32px;
        margin: 140px auto 0;
        color: #f6f8fa;
        text-align: center;
        width: 96px;
        background: linear-gradient(
          180deg,
          #4581fe 0%,
          rgba(69, 129, 254, 0.589) 50%,
          rgba(183, 206, 253, 0.59) 100%
        );
        border-radius: 4px 4px 4px 4px;
        border: none;
        height: 32px;
      }
    }
  }
}
.priceIndex-box_btn {
  color: white;
}
.priceIndex-dialog-box {
  width: 100%;
  margin: 0 auto;
}
.my-dialog {
  ::v-deep .el-dialog__header,
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
</style>
